// -----------------------------------------------------------------------------
// DeleteModal.jsx – design harmonisé avec AddAppelOffreForm / CustomModal adapté
// -----------------------------------------------------------------------------
import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  styled,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

/* ────────────────────────────────────────────────────────────────────────── */
/*  🎨   DESIGN TOKENS – identiques à AddAppelOffreForm                      */
/* ────────────────────────────────────────────────────────────────────────── */
const NAVY       = "#2F4E8B";
const NAVY_LIGHT = "#4a6bad";
const OUTLINE    = "#D4D9E0";
const LABEL_GREY = "#4F5565";

/* ───  Conteneur principal avec fond dégradé                                 */
const GradientPaper = styled(Paper)({
  borderRadius: 3,
  padding: 24,
  width: "100%",
  maxWidth: 400,
  margin: "0 auto",
  background:
    "linear-gradient(135deg, #FFFFFF 0%, #F6F9FC 60%, #E9F0F9 100%)",
  position: "relative",
});

/**
 * DeleteModal component for confirming deletion actions.
 *
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - onConfirm: () => void
 *  - message?: string
 */
const DeleteModal = ({ open, onClose, onConfirm, message }) => {
  return (
    <Modal open={open} onClose={null} disableBackdropClick>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          outline: "none",
        }}
      >
        <GradientPaper elevation={8}>
          {/* Close icon */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: LABEL_GREY,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Titre */}
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: 700, color: NAVY, mb: 2 }}
          >
            Confirmation de suppression
          </Typography>

          {/* Message */}
          <Typography
            align="center"
            sx={{ color: LABEL_GREY, mb: 4 }}
          >
            {message || "Êtes-vous sûr de vouloir supprimer cet élément ?"}
          </Typography>

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="contained"
              onClick={onConfirm}
              sx={{
                backgroundColor: NAVY,
                color: "#fff",
                textTransform: "none",
                px: 4,
                fontWeight: 600,
                borderRadius: 1,
                "&:hover": { backgroundColor: NAVY_LIGHT },
              }}
            >
              Supprimer
            </Button>
          </Box>
        </GradientPaper>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
